import $ from 'jquery';
import rimg from 'rimg-shopify';

export default class DynamicInstagram {
  constructor(section) {
    this.settings = section.data;
    this.onboarding = this.settings.onboarding;
    this.photoCount = this.settings.photoCount;
    this.accessToken = this.settings.accessToken;

    this.$el = $(section.el);
    this.$photoTemplate = $('[data-instagram-photo-template]', this.$el);
    this.$photoContainer = $('[data-instagram-photos]', this.$el);
    this.$contentPlaceholder = $('[data-instagram-content-placeholder]', this.$el);

    this.$photoTemplate.removeAttr('data-instagram-photo-template');
    this.$photoTemplate.remove();

    if (this.onboarding || !this.accessToken) {
      return;
    }

    this.$photoContainer.one('rimg:enter', () => {
      this._getPhotos()
        .done(photos => this._renderPhotos(photos))
        .fail((error) => {
          console.warn(`Instagram: ${error}`);
        });
    });
    rimg.watch(this.$photoContainer[0]);
  }

  _getPhotos() {
    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${ this.accessToken }&count=${ this.photoCount }&callback=`;
    const photoPromise = $.ajax(url, {
      dataType: 'jsonp',
    });

    return photoPromise.then(function(response) {
      if (response.meta.code != 200) {
        const error = `${ response.meta.error_message } (${ response.meta.error_type })`;
        return $.Deferred().reject(error).promise();
      }

      return response.data;
    });
  }

  _renderPhotos(photos) {
    const photoArray = [];

    // If we have more than 4 images, we want the nearest even number
    if (photos.length > 4 && photos.length % 2 === 1) {
      photos.pop();
    }

    this.$photoContainer.addClass(`instagram-photo-count-${photos.length}`);

    photos.forEach((photo) => {
      const $photo = this.$photoTemplate.clone();

      // Convert UNIX seconds to milliseconds and create Date object
      const date = new Date(photo.created_time * 1000);
      const dateOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      };
      const likes = photo.likes.count;
      const timestamp = date.toLocaleDateString(this.settings.locale, dateOptions);
      const caption = photo.caption && photo.caption.text ? photo.caption.text : '';

      const standard = photo.images.standard_resolution;
      const scale = standard.width > standard.height ? 'y' : 'x';

      const $image = $(`
        <a class="instagram-link" target="_blank" href="${photo.link}"></a>
        <img
          class="instagram-image instagram-image-scale-${scale}"
          src="${standard.url}"
        />
      `);

      $photo
        .removeClass('instagram-photo-template')
        .removeAttr('data-instagram-photo-template');

      $photo
        .find('[data-instagram-photo-template-likes]')
        .append(likes)
        .removeAttr('data-instagram-photo-template-likes');

      if (caption !== '') {
        $photo
          .find('[data-instagram-photo-template-caption]')
          .append(caption)
          .removeAttr('data-instagram-photo-template-caption');
      }

      $photo
        .find('[data-instagram-photo-template-timestamp]')
        .append(timestamp)
        .removeAttr('data-instagram-photo-template-timestamp');

      $photo
        .find('[data-instagram-photo-template-photo]')
        .append($image)
        .removeAttr('data-instagram-photo-template-photo');

      photoArray.push($photo);
    });

    this.$contentPlaceholder
      .fadeOut()
      .promise()
      .done(() => {
        this.$photoContainer.append(photoArray);
        this.$contentPlaceholder.remove();
      });
  }
}
